module.exports = __webpack_public_path__ + "static/media/tree-christmas.4ce10a00.svg";